<template>
  <div>
    <div class="top">班级缴费进度</div>
    <div class="contaa">   
      <div class="top2">
        <div class="toptitle">
          缴费结果<span class="numdata">（共{{ numdata }}条）</span>
        </div>
        <div v-if="datalist.length > 0">
          <div
            class="single"
            v-for="item in datalist"
            :key="item.id"
            @click="tonewpage(item)"
          >
            <van-cell :title="item.title" is-link></van-cell>
            <!-- <div class="one">
              <span>单价:{{ (item.summary.fee / 100).toFixed(2) }}元</span>
            </div> -->
            <div class="one">
              <span>应缴费学生:{{ item.summary.student_count }}人</span
              ><span>已缴费学生:{{ item.summary.student_count_paid }}人</span>
            </div>
            <div class="one">
              <span
                >应收费:{{ (item.summary.total_fee / 100).toFixed(2) }}元</span
              ><span
                >已收费:{{
                  (item.summary.total_fee_paid / 100).toFixed(2)
                }}元</span
              >
            </div>
          </div>
        </div>
        <div v-else>
          <van-empty description="暂无数据" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subdata: {},
      showtime: false,
      showschool: false,
      showclass: false,
      datalist: [],
      numdata: 0,
      subdata: {},
      columns: [],
      showschool: false,
      cascaderValue: "",
      show: false,
      showimfo: {},
      fieldNames: {
        text: "title",
        value: "key",
        children: "children",
      },
    };
  },

  mounted() {
    this.searchpay();
  },

  methods: {
    tonewpage(value) {
      this.$router.push({ path: "/hisimfo", query: { id: value.id,title: value.title} });
    },
    showPopup(value) {
      this.show = true;
      this.showimfo = value;
    },
    searchpay() {
      this.payitems = [];
      this.fetchget("/api/app/payment",{WithSummary:true}).then((res) => {
        if (res.code < 0) {
          this.$notify({
            type: "danger",
            message: res.msg,
            color: "#ad0000",
            background: "#ffe1e1",
          });
        } else {
          console.log(res);
          this.numdata = res.totalCount;
          this.datalist = res.items;
        }
      });
    },
    onFinish({ selectedOptions }) {
      this.showschool = false;
      let fieldValue = [];
      selectedOptions.map((option) => fieldValue.push(option));
      if (fieldValue.length > 1) {
        this.subdata.class =
          fieldValue[fieldValue.length - 2].title +
          fieldValue[fieldValue.length - 1].title;
      } else if (fieldValue.length == 1) {
        this.subdata.class = fieldValue[fieldValue.length - 1].title;
      }
      this.orid = fieldValue[fieldValue.length - 1].value;
      console.log(this.subdata, 777);
    },
   
  },
};
</script>

<style lang="scss" scoped>
.one {
  line-height: 30px;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  font-weight: normal;
  padding: 0 20px;
}
.contaa {
  // height:calc(100% - #{$--operation-height});
  overflow-y: auto;
}
.top {
  width: 375px;
  height: 44px;
  background-color: #dd0000;
  height: 44px;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 44px;
  letter-spacing: 1px;
  color: #ffffff;
}

.top2 {
  width: 375px;
  // min-height: 498px;

  .toptitle {
    width: 345px;
    height: 40px;
    text-align: left;
    color: #434343;
    font-size: 15px;
    font-weight: 600;
    line-height: 40px;
    border-bottom: 1px solid #eee;
    background-color: #ffffff;
    padding: 0 15px;
    margin-bottom: 7px;
    .numdata {
      font-weight: 100;
      letter-spacing: 1px;
      color: #434343;
      font-size: 14px;
    }
  }
  .single {
    margin-bottom: 7px;
    color: #000000;
    font-size: 14px;
    font-weight: 600;
    background-color: #ffffff;
    padding: 0 15px;
  }
  .price {
    color: #dd0000;
    font-size: 14px;
    font-weight: 600;
  }
}
</style>